import { useState, useEffect, useCallback } from 'react';
import supabase from '../supabase/supabase';

export const useAccessRequest = (userId) => {
  const [request, setRequest] = useState(null);
  const [loading, setLoading] = useState(true);

  // Fetch ANY existing request (not just pending) to prevent re-application
  const fetchRequest = useCallback(async () => {
    if (!userId) { setLoading(false); return; }
    try {
      const { data, error } = await supabase
        .from('d2f_admin_access_requests')
        .select('*')
        .eq('user_id', userId)
        .order('created_at', { ascending: false })
        .limit(1)
        .maybeSingle();

      if (error) console.error('fetchRequest error:', error);
      setRequest(data || null);
    } catch (e) {
      console.error('fetchRequest exception:', e);
    } finally {
      setLoading(false);
    }
  }, [userId]);

  useEffect(() => { fetchRequest(); }, [fetchRequest]);

  const submitRequest = async (payload) => {
    try {
      const { data, error } = await supabase.rpc('submit_creator_request', {
        p_email:             payload.email             || '',
        p_display_name:      payload.display_name      || '',
        p_requested_role:    payload.requested_role    || 'artist',
        p_reason:            payload.reason            || `Application for ${payload.requested_role || 'artist'} role`,
        p_experience:        payload.experience        || '',
        p_bio:               payload.bio               || '',
        p_social_spotify:    payload.social_spotify    || '',
        p_social_instagram:  payload.social_instagram  || '',
        p_social_soundcloud: payload.social_soundcloud || '',
        p_website:           payload.website           || '',
        p_user_id:           userId                    || null,
      });

      if (error) {
        console.error('submit_creator_request RPC error:', error);
        return { data: null, error: new Error(error.message || 'Failed to submit application') };
      }

      const record = typeof data === 'string' ? JSON.parse(data) : data;
      setRequest(record);
      return { data: record, error: null };
    } catch (err) {
      console.error('Unexpected submitRequest error:', err);
      return { data: null, error: err instanceof Error ? err : new Error('Failed to submit application') };
    }
  };

  return { request, loading, refetch: fetchRequest, submitRequest };
};